var Index_object_reviews_slider = document.querySelector('.Index_object_reviews_slider');

if (Index_object_reviews_slider) {
    new Swiper('.Index_object_reviews_slider', {
        loop: true,
        grabCursor: false,
        spaceBetween: 30,
        slidesPerGroup: 1,
        slidesPerView: 3,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        breakpoints: {
            0: {
                spaceBetween: 16,
                centeredSlides: true,
                slidesPerView: "auto"
            },
            750: {
                spaceBetween: 20,
                centeredSlides: false,
                slidesPerView: 3
            },
            990: {
                spaceBetween: 30,
            },
            1200: {
            },
            1440: {
            }
        }
    })
}